import './style.scss';
import { IconButton, InputProps, TextField as MuiTextField, TextFieldProps } from '@mui/material';
import { HTMLInputTypeAttribute } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import useState from '../../hooks/useState';


interface IStateValues {
    type: HTMLInputTypeAttribute | undefined;
}

const TextField: React.FC<TextFieldProps> = (props) => {
    const state = useState<IStateValues>({
        type: props.type
    });

    const InputPropsAux = { ...props.InputProps } as InputProps;

    if (props.type === 'password') {
        InputPropsAux.endAdornment = (
            <IconButton size="small" onClick={() => state.update('type', state.values.type === 'password' ? 'text' : 'password')}>
                {state.values.type === 'password' ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
            </IconButton>
        );
    }


    return (
        <MuiTextField
            {...props}
            type={state.values.type}
            variant={props.variant ?? 'filled'}
            color={props.color ?? 'primary'}
            fullWidth={true}
            margin={props.margin ?? 'normal'}
            required={props.required ?? true}
            autoComplete={'off'}
            InputProps={InputPropsAux}
            className={`textfield-default ${props.className ?? ''}`}
        />
    );
}

export default TextField;